import { ModuleConfig } from '@/core/module';
import { essBranchManagementRoutes } from './routes';

export const ESSBranchManagementModule: ModuleConfig = {
    name: 'ESSBranchManagement',
    routes: essBranchManagementRoutes,
};
